import { css } from "styled-components";
import { boxMixin, boxMixinPropsType } from "./box";
import { objectFitMixin } from "./objectFit";
import { objectPositionMixin, } from "./objectPosition";
export const imageBoxMixinPropsType = boxMixinPropsType.complete({
    _objectFit: true,
    _objectPosition: true,
});
export const imageBoxMixin = css `
  ${boxMixin}
  ${objectFitMixin}
  ${objectPositionMixin}
`;
export default imageBoxMixin;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW1hZ2VCb3guanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvbWl4aW5zL2ltYWdlQm94LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxHQUFHLEVBQUUsTUFBTSxtQkFBbUIsQ0FBQztBQUN4QyxPQUFPLEVBQUUsUUFBUSxFQUFpQixpQkFBaUIsRUFBRSxNQUFNLE9BQU8sQ0FBQztBQUNuRSxPQUFPLEVBQWEsY0FBYyxFQUF1QixNQUFNLGFBQWEsQ0FBQztBQUM3RSxPQUFPLEVBRUwsbUJBQW1CLEdBRXBCLE1BQU0sa0JBQWtCLENBQUM7QUFTMUIsTUFBTSxDQUFDLE1BQU0sc0JBQXNCLEdBQUcsaUJBQWlCLENBQUMsUUFBUSxDQUU5RDtJQUNBLFVBQVUsRUFBRSxJQUFJO0lBQ2hCLGVBQWUsRUFBRSxJQUFJO0NBQ3RCLENBQUMsQ0FBQztBQUVILE1BQU0sQ0FBQyxNQUFNLGFBQWEsR0FBRyxHQUFHLENBQW9CO0lBQ2hELFFBQVE7SUFDUixjQUFjO0lBQ2QsbUJBQW1CO0NBQ3RCLENBQUM7QUFFRixlQUFlLGFBQWEsQ0FBQyJ9